import React, { ReactNode } from 'react';
import { MenuItem as MuiMenuItem } from '@mui/material';

export interface MenuIemProps {
  children?: ReactNode;
  disabled?: boolean;
  href?: string;
  component?: React.ElementType;
  onClick?: () => void;
}

const MenuItem: React.FC<MenuIemProps> = (props) => {
  return <MuiMenuItem {...props} />;
};

export default MenuItem;
